<app-walkthrough-slide>
  <div copy class="wt-eyebrow">{{ 'app.pages.auth.walkthrough.pane7.eyebrow' | translate }}</div>
  <h2 copy class="wt-h2">{{ 'app.pages.auth.walkthrough.pane7.title' | translate }}</h2>
  <p copy class="wt-p">{{ 'app.pages.auth.walkthrough.pane7.body' | translate }}</p>

  <div copy class="wt-bul">
    <div class="wt-bul__i wt-bul__i--hi">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane7.bullet.devices' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane7.bullet.nothingLost' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane7.bullet.payments' | translate }}</span>
    </div>
  </div>

  <!-- 1 · the hub -->
  <div viz class="vhub">
    <ion-icon name="desktop-outline" aria-hidden="true"></ion-icon>
    <span>{{ 'app.pages.auth.walkthrough.pane7.hub' | translate }}</span>
  </div>

  <!-- 2 · the connector. The vertical rule is a `::before`, not an element:
       it is a line in a drawing, and it carries no text. -->
  <div viz class="vlink">
    <span>{{ 'app.pages.auth.walkthrough.pane7.link' | translate }}</span>
  </div>

  <!-- 3 · the three local peers -->
  <div viz class="vdevs">
    @for (device of devices; track device.labelKey) {
      <div class="vdev">
        <ion-icon [name]="device.icon" aria-hidden="true"></ion-icon>
        <span>{{ device.labelKey | translate }}</span>
      </div>
    }
  </div>

  <!-- 4 · rule -->
  <div viz class="vsep" aria-hidden="true"></div>

  <!-- 5 · the queue flow: three clerks → queue → display -->
  <div viz class="vq">
    <div class="vqc">
      @for (clerk of clerks; track clerk) {
        <span>{{ clerk | translate }}</span>
      }
    </div>
    <ion-icon name="arrow-forward" aria-hidden="true"></ion-icon>
    <div class="vqb">{{ 'app.pages.auth.walkthrough.pane7.queue' | translate }}</div>
    <ion-icon name="arrow-forward" aria-hidden="true"></ion-icon>
    <div class="vqb">{{ 'app.pages.auth.walkthrough.pane7.display' | translate }}</div>
  </div>

  <!-- 6 · the sync pill. Centred on its own, hence a modifier rather than an
       alignment rule on the stack, which would move its siblings too. -->
  <div viz class="vsync">
    <ion-icon name="cloud-done-outline" aria-hidden="true"></ion-icon>
    <span>{{ 'app.pages.auth.walkthrough.pane7.sync' | translate }}</span>
  </div>

  <!-- 7 · footnote -->
  <div viz class="vfoot">{{ 'app.pages.auth.walkthrough.pane7.foot' | translate }}</div>
</app-walkthrough-slide>
